import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useHighlightStyles from './styles';
import KanbanCard from '../Kanban/KanbanCard';

function HighlightsAccordion({
  rawLines = [],
  defaultExpanded = true,
  handleClick,
  onUpdateCard,
}) {
  const classes = useHighlightStyles();

  const highLightLevels = [1, 2, 3];
  const favorites = useMemo(() => (
    rawLines
      .filter(line => highLightLevels.includes(line.highlight_level))
      .slice()
      .sort((a, b) => a.highlight_level - b.highlight_level)
  ), [rawLines]);

  return (
    <ExpansionPanel
      defaultExpanded={defaultExpanded}
      elevation={0}
      className={classes.root}
      classes={{
        root: classes.panelRoot,
        expanded: classes.panelExpanded,
      }}
    >
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.summary}
        classes={{
          root: classes.summaryRoot,
          content: classes.summaryContent,
          expanded: classes.expanded,
        }}
      >
        <div className={classes.titleWrapper}>
          <span className={classes.titleDot} />
          <Typography className={classes.titleText}>
            Destaques
          </Typography>
          <Typography className={classes.counter}>
            (
            {favorites.length}
            )
          </Typography>
        </div>
      </ExpansionPanelSummary>

      <ExpansionPanelDetails className={classes.details}>
        {favorites.length === 0 ? (
          <Typography color="textSecondary" style={{ fontSize: 14 }}>
            Nenhum favorito no momento.
          </Typography>
        ) : (
          <div className={classes.scroller}>
            {favorites.map(card => (
              <div
                key={card.id}
                role="button"
                tabIndex={0}
                className={classes.cardWrap}
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof handleClick === 'function') handleClick(card, card.id_unitary_operation);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof handleClick === 'function') handleClick(card, card.id_unitary_operation);
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <KanbanCard
                  card={card}
                  onUpdate={(patch) => {
                    const next = { ...card, ...patch };
                    onUpdateCard(next);
                  }}
                  showRibbon
                  // showFlag={true}
                />
              </div>
            ))}
          </div>
        )}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

HighlightsAccordion.propTypes = {
  rawLines: PropTypes.array,
  defaultExpanded: PropTypes.bool,
  handleClick: PropTypes.func,
  onUpdateCard: PropTypes.func,
};

HighlightsAccordion.defaultProps = {
  rawLines: [],
  defaultExpanded: true,
  handleClick: () => {},
  onUpdateCard: () => {},
};

export default HighlightsAccordion;
